import React, { useState, useEffect } from 'react';
import { Card, Col, Dropdown, DropdownButton, Form, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { BiCheck  } from "react-icons/bi";
import { AlertFillIcon, PersonAddIcon, SearchIcon } from '@primer/octicons-react'
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
//import configInfo from '../config/config.json';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import configInfo from '../config/config.json';
import classes from './AdminPages.module.css';


const UserAdminListView = (props) => {

  const { i18n, t } = useTranslation(['common', 'custom']);

  const [errMsg,      setErrMsg]      = useState('');
  const [notFoundMsg, setNotFoundMsg] = useState('');

  const [searchTerms, setSearchTerms] = useState();

  const [searchField, setSearchField] = useState('Name');

  const searchFieldOptions = [
    { key: "Name",      value: "Name" },
    { key: "Dept",      value: "Dept" },
/*
    { key: "Job_title", value: "Job_title" },
*/
    { key: "Status",    value: "Status" }
  ];

  const statusOptions = [
    { key: "USR_ST_ACTIVE",                  value: "USR_ST_ACTIVE" },
    { key: "USR_ST_LOCKED",                  value: "USR_ST_LOCKED" },
    { key: "USR_ST_PEND_ACTV",               value: "USR_ST_PEND_ACTV" },
    { key: "USR_ST_FORGOT_PWD_PEND_EMAIL_V", value: "USR_ST_FORGOT_PWD_PEND_EMAIL_V" },
    { key: "USR_ST_ADMIN_PWD_PEND_EMAIL_V",  value: "USR_ST_ADMIN_PWD_PEND_EMAIL_V" },
    { key: "USR_ST_READY_TO_SET_PWD",        value: "USR_ST_READY_TO_SET_PWD" },
    { key: "USR_ST_READY_TO_SET_SEC_N_PWD",  value: "USR_ST_READY_TO_SET_SEC_N_PWD" },
    { key: "USR_ST_DISABLED",                value: "USR_ST_DISABLED" },
    { key: "USR_ST_SUSPENDED",               value: "USR_ST_SUSPENDED" },
    { key: "USR_ST_DEACTIVATED",             value: "USR_ST_DEACTIVATED" }
  ];

  // ----- Data Table stuff -----

  const [objList,   setObjList]   = useState([]);
  const [totalRows, setTotalRows] = useState();
  const [perPage,   setPerPage]   = useState(25);
  const [currPage,  setCurrPage]  = useState(1);
  const [sortCol,   setSortCol]   = useState(null);
  const [sortDir,   setSortDir]   = useState(null);

  const customStyles = {
    rows: {
      style: {
        minHeight: '25px', // override the row height
        fontSize: '11px',
      },
    }
  };

  const omit_fullName      = !configInfo.uiConfig.visibleFields.USER_fullName;
  const omit_fullNameLang2 = !configInfo.uiConfig.visibleFields.USER_fullNameLang2;
  const omit_jobTitle      = !configInfo.uiConfig.visibleFields.USER_jobTitle;
  const omit_dept          = !configInfo.uiConfig.visibleFields.USER_dept;
  const omit_email         = !configInfo.uiConfig.visibleFields.USER_email;
  const omit_mobilePhone   = !configInfo.uiConfig.visibleFields.USER_mobilePhone;

  const columns = [
    {
      name: t("I18N_Username"),
      selector: row => row.username,
      sortable: true,
      sortField: 'username',
      cell: row => (
        <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleObjDetails(row)}>{row.username}</span>
      ),
    },
    {
      name: t("I18N_Full_name"),
      selector: row => row.surname,
      cell: row => (
        (row.surname ? row.surname + ', ' : '') + (row.givenName ? row.givenName : '') + (row.middleName ? ' ' + row.middleName : '')
      ),
      sortable: true,
      sortField: 'fullName',
      omit: omit_fullName
    },
    {
      name: t("custom:I18N_Full_name_lang2"),
      selector: row => row.fullNameLang2,
      sortable: true,
      sortField: 'fullNameLang2',
      omit: omit_fullNameLang2
    },
    {
      name: t("I18N_Job_title"),
      selector: row => row.jobTitle,
      sortable: true,
      sortField: 'jobTitle',
      omit: omit_jobTitle
    },
    {
      name: t("I18N_Dept_name"),
      selector: row => row.deptName,
      cell: row => (
         (i18n.language === 'en') ? row.deptName : (i18n.language === 'zh_HK' ? row.deptNameLang2 : row.deptNameLang3)
      ),
      sortable: true,
      sortField: 'deptName',
      omit: omit_dept
    },
    {
      name: t("I18N_Email"),
      selector: row => row.email,
      omit: omit_email
    },
    {
      name: t("I18N_Mobile_phone"),
      selector: row => row.mobilePhone,
      omit: omit_mobilePhone
    },
    {
      name: t("I18N_User_status"),
      selector: row => row.status,
      cell: row => (
        t("I18N_" + row.status)
      ),
      sortable: true,
      sortField: 'status',
      grow: 0.5,
    },
    {
      name: t("I18N_Time_created"),
      selector: row => row.timeCreated,
      cell: row => (
        formatDate(row.timeCreated)
      ),
      sortable: true,
      sortField: 'timeCreated',
      grow: 0.5,
    },
    {
      name: t("I18N_Data_integrity"),
      cell: row => (
        !row.dataIntegrity ? <><span style={{color: 'red'}}><AlertFillIcon size={16} /> </span>  <span style={{marginLeft:'5px', color: 'red'}}>{t("I18N_Integrity_check_failed")}</span></> :
                             <><span style={{color: 'green'}}><BiCheck size={16} /> </span>  <span style={{marginLeft:'5px', color: 'green'}}>{t("I18N_Integrity_check_success")}</span></>
      ),
      grow: 0.5,
      omit: !configInfo.appConfig.checkDataIntegrity
    }
  ];


  const fetchObjs = async (searchTerms, sortCol, sortDir, perPage, currPage) => {

    let tmpSearchTerms;

    switch (searchField) {
      case 'Name':
            tmpSearchTerms = (searchTerms && (searchTerms !== null)) ? encodeURIComponent(searchTerms) : '';
            break;
      case 'Dept':
            tmpSearchTerms = searchDept.id;
            break;
      case 'Job_title':
            tmpSearchTerms = (searchTerms && (searchTerms !== null)) ? encodeURIComponent(searchTerms) : '';
            break;
      case 'Status':
            tmpSearchTerms = searchStatus;
            break;
      default:
            tmpSearchTerms = (searchTerms && (searchTerms !== null)) ? encodeURIComponent(searchTerms) : '';
            break;
    }

    try {
      const res = await axiosAuth_IDENT_MGMT_API.get("users?searchTerms=" + tmpSearchTerms + "&searchField=" + searchField +
                                                    ((sortCol     && (sortCol     !== null)) ? ("&sortColumn=" + sortCol + "&sortDirection=" + sortDir) : '')  +
                                                    ((perPage     && (perPage     !== null)) ? ("&limit="      + perPage)                               : '')  +
                                                    ((currPage    && (currPage    !== null)) ? ("&offset="     + (currPage - 1) * perPage)              : ''));

      if (!res.data.data || (res.data.data.length === 0)) {
        setNotFoundMsg("I18N_No_search_result");
      } else {
        setNotFoundMsg('');
      }

      setObjList(res.data.data);

      setTotalRows(res.data.total);
      setErrMsg('');
    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  };


  const handlePageChange = currPage => {
    setCurrPage(currPage);
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    currPage});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, currPage);
  };


  const handlePerRowsChange = async (newPerPage) => {

    setPerPage(newPerPage);
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     newPerPage,
                          currPage:    currPage});

    fetchObjs(searchTerms, sortCol, sortDir, newPerPage, currPage);
  };


  const handleSort = (column, sortDir) => {

    // instead of setTimeout this is where you would handle your API call.
    setSortCol (column.sortField);
    setSortDir (sortDir);

    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     column.sortField,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, column.sortField, sortDir, perPage, 1);
  };

  const paginationComponentOptions={
          rowsPerPageText: t("I18N_Rows_per_page"),
          rangeSeparatorText: t("I18N_Pagination_page_of_total"),
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: 'All'
        };

  // ----- END - Data Table stuff -----

  // Initialize state
  useEffect(() => {

    setSearchTerms(props.pageState.searchTerms);
    setSortCol(props.pageState.sortCol);
    setSortDir(props.pageState.sortDir);
    setPerPage(props.pageState.perPage);
    setCurrPage(props.pageState.currPage);

    fetchObjs(props.pageState.searchTerms, props.pageState.sortCol, props.pageState.sortDir, props.pageState.perPage, props.pageState.currPage);

    fetchDepts();

    if (configInfo.uiConfig.visibleFields.USER_dept)
      searchFieldOptions.push({ key: "Dept",      value: "Dept" });
    if (configInfo.uiConfig.visibleFields.USER_jobRTitle)
      searchFieldOptions.push({ key: "Job_title", value: "Job_title" });

    if (!configInfo.appConfig.isSimpleUserCreation) {
      statusOptions.push({ key: "USR_ST_PEND_ACTV",               value: "USR_ST_PEND_ACTV" });
      statusOptions.push({ key: "USR_ST_FORGOT_PWD_PEND_EMAIL_V", value: "USR_ST_FORGOT_PWD_PEND_EMAIL_V" });
      statusOptions.push({ key: "USR_ST_ADMIN_PWD_PEND_EMAIL_V",  value: "USR_ST_ADMIN_PWD_PEND_EMAIL_V" });
      statusOptions.push({ key: "USR_ST_READY_TO_SET_PWD",        value: "USR_ST_READY_TO_SET_PWD" });
      statusOptions.push({ key: "USR_ST_READY_TO_SET_SEC_N_PWD",  value: "USR_ST_READY_TO_SET_SEC_N_PWD" });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onInputChange = (e) => {
    setSearchTerms(e.target.value)
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    setCurrPage(1); // Reset to page 1 for a fresh search
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, 1);
  }


/*
  const searchUser = (searchTerms, fullList) => {

    if (fullList)
      searchTerms = '';

    if (searchField === 'Dept')
      searchTerms = parseInt(searchDept.id);
    else if (searchField === 'Status')
      searchTerms = searchStatus;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("users?searchTerms=" + encodeURIComponent(searchTerms) + "&searchField=" + searchField);

        resolve(res.data);

        if (res.status === 200) {
          setObjList(res.data);

          if (res.data.length === 0) {
            setNotFoundMsg("I18N_No_search_result");
          } else {
            setNotFoundMsg('');
          }
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }
*/


  // Department search
  const [deptList,     setDeptList]     = useState([]);
  const [searchDept,   setSearchDept]   = useState([]);

  const fetchDepts = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("departments");

        resolve(res.data);

        if (res.status === 200) {

          for (let i=0; i<res.data.length; i++) {
            res.data[i].displayName = [];
            res.data[i].displayName['en']    = res.data[i].name;
            res.data[i].displayName['zh_HK'] = res.data[i].nameLang2;
            res.data[i].displayName['zh_CN'] = res.data[i].nameLang3;
          }

          setDeptList(res.data);
          setSearchDept(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const onDeptSelect = (key, event) => {
    setSearchDept({id: key});
  };


  // Status search
  const [searchStatus, setSearchStatus] = useState('USR_ST_ACTIVE');

  const onStatusSelect = (key, event) => {
    setSearchStatus(key);
  };

  const onSearchFieldSelect = (key, event) => {
    setSearchField(key);
  };


  function handleObjDetails(user) {

    // ### There maybe a need to translate the raw DB data to model data.  For, just take as is. ###
    props.onSetObjDetails(user);

    props.onUIMode('DETAILS')
  }

  // Create new user
  const handleNewUser = (e) => {
    e.preventDefault();
    props.onUIMode('NEW')
  }


  return (
    <>
      <Card className='aaa' style={{ border: '0', boxShadow: '0 2px 2px 0px rgba(0,0,0,0.1)', padding: '20px 40px 20px 40px', maxWidth: '2500px', height: '850px', width: '100%' }}>

        <div style={{ display: 'flex' }}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_User_Management")}
          </span>
          <span style={{marginLeft:'auto', marginTop:'7px', color:'rgba(200,0,0)', fontSize:'12px'}}>
            {errMsg}
          </span>

{/*
          { configInfo.appConfig.isPrimaryIdentProvider ?
*/}
            <OverlayTrigger overlay={<Tooltip id="tooltip-new_location" style={{fontSize:'11px'}}>{t("I18N_TIP_New_user")}</Tooltip>}>
              <span onClick={handleNewUser} style={{ marginLeft: 'auto', marginRight: '0px', marginTop: '5px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                <PersonAddIcon size={18} />
              </span>
            </OverlayTrigger>
{/*
          :
            null
          }
*/}

          { configInfo.uiConfig.visibleFields.USER_search ?
          <>
          <span style={{ marginLeft: '30px', marginTop: '8px', fontSize: '12px', minWidth: '30px' }}>
            {t("I18N_Search_field")}:
          </span>
          <span style={{ marginLeft: '10px', marginRight: '0px', marginTop: '2px', minWidth: '20px' }}>
            <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
              title={ !searchField ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + searchField) }
              style={{ width: '130px' }}
              onSelect={onSearchFieldSelect}>
              {searchFieldOptions.map((item, index) => {
                return (
                  <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap} style={{ width: '100%' }}>
                    {t("I18N_" + item.value)}
                  </Dropdown.Item>
                );
              })}
            </DropdownButton>
          </span>

          <span style={{ marginLeft: '20px', marginRight: '0px', width: '250px', minWidth: '400px' }}>
            <Form onSubmit={handleSearchSubmit}>
              <Form.Group as={Row}>
                <Col sm="10">
                  { searchField && searchField === 'Dept' ?
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!searchDept.id ? t("I18N_No_dept") :
                             deptList.find(item => item.id.toString() === searchDept.id.toString()).displayName[i18n.language]}
                      style={{marginTop:'2px'}}
                      onSelect={onDeptSelect}>
                      {deptList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                            {item.displayName[i18n.language]}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  : searchField && searchField === 'Status' ?
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={t("I18N_" + searchStatus)}
                      style={{ marginTop:'2px' }}
                      onSelect={onStatusSelect}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap} style={{ width: '100%' }}>
                            {t("I18N_" + item.key)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  :
                    <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerms" value={searchTerms ? searchTerms : ''}
                                  onChange={(e) => onInputChange(e)} placeholder={t("I18N_Search_terms")} />
                  }
                </Col>
                <Col sm="2" style={{ padding: '5px' }}>
                  <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-search" style={{fontSize:'11px'}}>{t("I18N_Search")}</Tooltip>}>
                    <span onClick={handleSearchSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={18} />
                    </span>
                  </OverlayTrigger>
                </Col>
              </Form.Group>
            </Form>
          </span>
          </>
          : null
          }

        </div>

{/*
        <div style={{ display: 'flex' }}>
          <span className={classes.admin_pages__field_label} style={{marginLeft:'auto'}} >
            {t("I18N_Total")} :
          </span>
          <span style={{marginLeft:'5px', marginRight:'0px'}} className={classes.admin_pages__field_label}>
            {userList.length}
          </span>
        </div>
*/}

        { (notFoundMsg && notFoundMsg !== '') ?
          <span className={classes.admin_pages__field_value} style={{marginTop:'20px'}}>
            {t(notFoundMsg)}
          </span>
        :
          <div style={{ overflowY:'auto', fontSize:'11px', marginTop:'10px' }}>

            { objList && objList.length > 0 ?
              <DataTable
                columns={columns}
                data={objList}
                customStyles={customStyles}
                fixedHeader
                fixedHeaderScrollHeight={'700px'}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationDefaultPage={currPage}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[25,50,100]}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                onSort={handleSort}
                sortServer
                highlightOnHover
                paginationComponentOptions={paginationComponentOptions}
              />
            : null
            }

          </div>
        }
      </Card>
    </>
  );

}

export default UserAdminListView;
